import { margin } from 'polished'

export const __widget = ({ isEnabled, size, theme }) => ({
	width: `${size}`,
	height: `${size}`,
	position: 'relative',
	display: 'flex',
	color: theme.primary(theme).backgroundColor,
	'& > input': {
		width: '100%',
		height: '100%',
		position: 'absolute',
		margin: '0',
		top: '50%',
		left: '0',
		transform: 'translateY(-50%)',
		opacity: '0',
		cursor: `${isEnabled ? 'pointer' : 'default'}`,
	},
	'& > p': {
		paddingLeft: '5px',
	},
})

export const __label = ({ fontSize, theme }) => ({
	...margin('0', '0', '0', theme.spaces[16]),
	cursor: 'pointer',
	userSelect: 'none',
	fontSize: fontSize || 16,
	color: '#333333',
})

export const __message = props => ({
	color: '#777777',
	fontSize: props.theme.fontSize.s,
	marginTop: '4px',
})

export const __text = props => {
	const { theme, hasError } = props
	const primary = theme.primary(theme)

	return {
		position: 'absolute',
		bottom: '-1.5rem',
		left: '0',
		color: hasError ? primary.errorColor : '#999999',
		fontSize: theme.font.size12,
		'> svg': {
			marginRight: '4px',
			marginTop: '-2px',
		},
	}
}
